// extracted by mini-css-extract-plugin
module.exports = {"DetailsProduct":"ProductDtls_DetailsProduct__sE_Si"};